// works immediately, no fetch needed
const APP_VERSION = process.env.REACT_APP_VERSION || 'dev';


export default function AppVersion() {
  return <span className="app-version">v{APP_VERSION}</span>;
}